import styled from "styled-components";

export const EmptyStateWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  padding: 64px 0;
  border-radius: 8px;

  @media (max-width: 767px) {
    padding: 48px 0;
  }
`;

export const EmptyStateIconWrapper = styled.div`
  width: 126px;
  height: 138px;

  display: flex;
  align-items: center;
  justify-content: center;
`;

export const EmptyStateTextWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  align-items: center;
  justify-content: center;
  width: 100%;
  max-width: 832px;

  @media (max-width: 767px) {
    max-width: 100%;
    padding: 0 16px;
  }
`;

interface EmptyStateTitleProps {
  color?: string;
}

export const EmptyStateTitle = styled.h2<EmptyStateTitleProps>`
  font-weight: 600;
  font-size: 20px;
  line-height: 1.5;
  letter-spacing: 0;
  text-align: center;
  color: ${({ color }) => color || "var(--text-title, #0f172a)"};
  margin: 0;
  word-break: normal;
  overflow-wrap: break-word;
  hyphens: none;

  @media (max-width: 767px) {
    font-size: 18px;
  }
`;

interface EmptyStateDescriptionProps {
  color?: string;
}

export const EmptyStateDescription = styled.p<EmptyStateDescriptionProps>`
  font-weight: 400;
  font-size: 16px;
  line-height: 20px;
  letter-spacing: 0;
  text-align: center;
  color: ${({ color }) => color || "var(--text-body, #475569)"};
  margin: 0;
  word-break: normal;
  overflow-wrap: break-word;
  hyphens: none;

  @media (max-width: 767px) {
    font-size: 14px;
    line-height: 18px;
  }
`;

export const EmptyStateButtonWrapper = styled.div`
  margin-top: 16px;
`;

